import React from 'react';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { ButtonToggles } from '@eika/radio-button';

import { StringKeyValue } from '../../../actions/types';
import { CalculatorReducer } from '../../../reducers/calculator';
import LoanType from '../../../util/mappings/loanType';

interface Props {
    onChange: (loanType: string) => void;
    calculator: CalculatorReducer;
    text: StringKeyValue;
    selected: string;
}

const LoanTypeSelection = ({ calculator, text, selected, onChange }: Props): JSX.Element => {
    const { isLoanCommitment, isCar } = calculator;

    const loanTypeValues = [
        {
            label: text.calculatorLoanTypeSelectionButtonLoan,
            value: LoanType.loan,
        },
        {
            label: text.calculatorLoanTypeSelectionButtonLoanCommitment,
            value: LoanType.loanCommitment,
        },
    ];

    return (
        <div className="loan-type-selection">
            <div className="loan-type-selection__button-group input-wrapper">
                <ButtonToggles
                    label={text.calculatorLoanTypeSelectionLabel}
                    options={loanTypeValues}
                    selectedOption={selected}
                    onChange={(loanType) => onChange(loanType)}
                />
            </div>
            {isLoanCommitment && (
                <InfoMessage
                    className="loan-type-selection__info-message"
                    icon={IconTypes.LYSPAERE_24}
                    text={
                        isCar
                            ? text.calculatorLoanTypeSelectionInfoBoxLoanCommitmentCar
                            : text.calculatorLoanTypeSelectionInfoBoxLoanCommitmentOther
                    }
                />
            )}
        </div>
    );
};

export default LoanTypeSelection;
